import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipBubble = styled.div`
  position: absolute;
  z-index: 1000;
  min-width: 200px;
  width: 200px; 
  background-color: rgba(97, 97, 97, 0.92);
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: normal;  
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  ${(props) =>
    props.position === 'top'
      ? `
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 8px;
      `
      : `
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 8px;
      `}
`;

const Tooltip = ({ children, content, position = 'top' }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <TooltipContainer ref={ref} onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)} onClick={() => setVisible((prev) => !prev)}>
      {children}
      {visible && <TooltipBubble position={position}>{content}</TooltipBubble>}
    </TooltipContainer>
  );
};

export default Tooltip;
